export default "__VITE_ASSET__B6JzmV5t__"